import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import './TestAnalytics.css';

const ScoreDistributionChart = ({ results, totalMarks }) => {
  const data = useMemo(() => {
    if (!results || results.length === 0 || !totalMarks) return [];
    
    let low = 0; // 0-50%
    let med = 0; // 50-75%
    let high = 0; // 75-100%

    results.forEach(r => {
      const p = (r.score / totalMarks) * 100;
      if (p < 50) low++;
      else if (p < 75) med++;
      else high++;
    });

    return [
      { name: '< 50%', count: low, color: '#ef4444' }, // Red
      { name: '50% - 75%', count: med, color: '#eab308' }, // Yellow
      { name: '> 75%', count: high, color: '#22c55e' } // Green
    ];
  }, [results, totalMarks]);

  if (data.length === 0) {
    return (
      <div className="ta-chart-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
        <p style={{ color: '#64748b' }}>Not enough data for Score Distribution.</p>
      </div>
    );
  }

  return (
    <div className="ta-chart-container">
      <h4 className="ta-chart-title">Score Distribution</h4>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
          <XAxis dataKey="name" tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} axisLine={false} tickLine={false} />
          <Tooltip cursor={{ fill: '#f1f5f9' }} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }} />
          <Bar dataKey="count" radius={[6, 6, 0, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScoreDistributionChart;
